/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
// 纯web方式兜底
var getLocation = function (params) {
    var _a = params.success, success = _a === void 0 ? function () { } : _a, _b = params.fail, fail = _b === void 0 ? function () { } : _b, _c = params.complete, complete = _c === void 0 ? function () { } : _c;
    if ('geolocation' in navigator) {
        /* 地理位置服务可用 */
        navigator.geolocation.getCurrentPosition(function (position) {
            var coords = position === null || position === void 0 ? void 0 : position.coords;
            success(coords);
            complete(coords);
        }, function (err) {
            fail(err);
            complete(err);
        });
    }
    else {
        /* 地理位置服务不可用 */
        var err = { code: -1, message: '地理位置服务不可用' };
        fail(err);
        complete(err);
    }
};

export { getLocation as default };
